import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useMemo } from "react"
import { useUserBidsQueryResultReatom } from "../hooks.reatom"

export const useTableItemsReatom = () => {
  const query = useUserBidsQueryResultReatom()

  const queryResult = useMemo(
    () => ({
      ...query,
      pages: query.data.pages.map((page) => ({
        items: page.bids,
      })),
    }),
    [query],
  )

  return useInfiniteTableItems(queryResult)
}
